import { defineStore } from 'pinia';

// Unintegrated feature previews stay separate from authenticated API-owned records.
function initialState() {
  return {
    // Unknown until the patient or the care team sets it.
    dryWeight: null,
    microEducationCompleted: false,
    assistantMessages: [],
    assistantContext: null,
  };
}

export const usePreviewStore = defineStore('preview', {
  state: initialState,
});
